import { Link } from "react-router-dom";

import "../styles/Footer.css";

import logo from "../images/logo-footvision-transparent.png";

import {

  FaFacebook,

  FaTelegram,

  FaInstagram,

  FaYoutube,

  FaTiktok

} from "react-icons/fa";


function Footer() {

  return (

    <footer className="footer">

      <div className="footer-top">

        {/* LOGO */}

        <div className="footer-brand">

          <h2>
            FootVision <span>Live</span>
          </h2>
       
       <p>Voir les matchs avant qu'ils commencent </p>
          <p>

            Pronostics • Analyses • Lives •
            Signaux Football • Compos des matchs

          </p>

        </div>

        {/* LIENS */}

        <div className="footer-links">

          <h3>
            Navigation
          </h3>

          <a href="/">
            Accueil
          </a>

          <a href="/matches">
            Matchs
          </a>

             <a href="/vip/compositions">
            Compos
          </a>

          <a href="/vip">
            VIP
          </a>

          <a href="/matches/search">
            Recherche
          </a>

        </div>



      </div>

      {/* BOTTOM */}

      <div className="footer-bottom">


        <div className="footer-legal">
         
          <h3>
           Légal
          </h3>

          <br></br>

          <Link to="/privacy">

  Politique de confidentialité

</Link>

<Link to="/terms">

  Conditions d'utilisation

</Link>

<Link to="/legal">

  Mentions légales

</Link>

<Link to="/cookies">

  Cookies

</Link>

<Link to="/responsible-gaming">

  Jeu responsable

</Link>        

</div>


              {/* SOCIAL */}

        <div className="footer-social">

          <h3>
            Réseaux sociaux
          </h3>

          <div className="social-icons">

            <a href="https://www.facebook.com/profile.php?id=61591294123537">
              <FaFacebook />
            </a>

            <a href="https://t.me/footvisionlive">
              <FaTelegram />
            </a>

              <a href="https://www.youtube.com/@footvisionlive-d5l">
              <FaYoutube />
            </a>

            <a href="https://www.instagram.com/footvision_live/">
              <FaInstagram />
            </a>

            <a href="https://www.tiktok.com/@footvision.live">
              <FaTiktok />
            </a>

          </div>

        </div>

      </div>

        <div className="copyright">

    <span> © 2026 FootVision v1.0</span>   
   <span>  Tous droits réservés.</span>     
  
        </div>

    </footer>

  );

}

export default Footer;